import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Alert } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';
import { useAuth } from '../context/AuthContext';
import SunIllustration from '../components/SunIllustration';

export default function SignUpScreen({ navigation }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const { signup, loading } = useAuth();

  async function handleSignUp() {
    if (!email || !password || !confirm) {
      Alert.alert('Error', 'Please fill in all fields');
      return;
    }
    if (password !== confirm) {
      Alert.alert('Error', 'Passwords do not match');
      return;
    }
    const result = await signup(email, password);
    if (!result.success) {
      Alert.alert('Sign Up Failed', result.error || 'Please try again');
    }
  }

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.inner}>
        <View style={styles.sunWrap}><SunIllustration size={75} /></View>
        {[
          { label: 'Email address', value: email, set: setEmail, type: 'email' },
          { label: 'Password', value: password, set: setPassword, type: 'password' },
          { label: 'Confirm Password', value: confirm, set: setConfirm, type: 'password' },
        ].map(function(field, i) {
          return (
            <View key={i} style={styles.fieldWrap}>
              <Text style={styles.label}>{field.label}</Text>
              <TextInput
                style={styles.input}
                placeholder={field.label}
                placeholderTextColor="rgba(255,255,255,0.45)"
                value={field.value}
                onChangeText={field.set}
                secureTextEntry={field.type === 'password'}
                keyboardType={field.type === 'email' ? 'email-address' : 'default'}
                autoCapitalize="none"
              />
            </View>
          );
        })}
        <TouchableOpacity style={styles.button} onPress={handleSignUp} disabled={loading}>
          <Text style={styles.buttonText}>{loading ? 'Creating account...' : 'Sign Up'}</Text>
        </TouchableOpacity>
        <Text style={styles.orText}>or sign up with</Text>
        <View style={styles.socialRow}>
          {['logo-facebook', 'logo-google', 'logo-apple'].map(function(icon) {
            return (
              <TouchableOpacity key={icon} style={styles.socialBtn}>
                <Icon name={icon} size={22} color="#fff" />
              </TouchableOpacity>
            );
          })}
        </View>
        <View style={styles.bottomRow}>
          <Text style={styles.bottomText}>Already have an account? </Text>
          <TouchableOpacity onPress={function() { navigation.navigate('Login'); }}>
            <Text style={styles.linkText}>Log in now</Text>
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.splashBot },
  inner: { flex: 1, paddingHorizontal: 32 },
  sunWrap: { alignItems: 'center', marginVertical: 20 },
  fieldWrap: { marginBottom: 12 },
  label: { color: '#fff', fontSize: 14, fontWeight: '600', marginBottom: 5 },
  input: { backgroundColor: 'rgba(255,255,255,0.25)', borderRadius: 10, padding: 12, paddingHorizontal: 16, color: '#fff', fontSize: 15 },
  button: { backgroundColor: Colors.primary, paddingVertical: 14, borderRadius: 25, alignItems: 'center', alignSelf: 'center', width: '60%', marginTop: 14 },
  buttonText: { color: '#fff', fontSize: 16, fontWeight: '600' },
  orText: { textAlign: 'center', color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 16 },
  socialRow: { flexDirection: 'row', justifyContent: 'center', gap: 16, marginTop: 8 },
  socialBtn: { width: 44, height: 44, borderRadius: 22, backgroundColor: 'rgba(255,255,255,0.2)', alignItems: 'center', justifyContent: 'center' },
  bottomRow: { flexDirection: 'row', justifyContent: 'center', marginTop: 20 },
  bottomText: { color: 'rgba(255,255,255,0.8)', fontSize: 13 },
  linkText: { color: Colors.accent, fontSize: 13, fontWeight: '600' },
});
